module.exports = __webpack_public_path__ + "img/0499e6_d4e8f1686c6e43939a674bc54a4651d4_mv2.77d7a1fc.webp";